$(document).ready(function () {
    // $('.section-template--14625958592567__ss_masonry_grid_QXKMyw img').attr('data-fancybox', 'gallery');

// $('[data-fancybox="gallery"]').fancybox({
//   buttons: [
//     "slideShow",
//     "thumbs",
//     "zoom",
//     "fullScreen",
//     "share",
//     "close"
//   ],
//   loop: false,
//   protect: true,
//   compact: true
// });

  let images = document.querySelectorAll('.flickity-slider .product-gallery__image img');
images.forEach(img => {
  
    if (img.alt.includes('sizes')) {
      $('.slider-sizes').css('display', 'block');
    }
    if (img.alt.includes('inspiration')) {
      $('.slider-inspiration').css('display', 'block');
    }
    if (img.alt.includes('unfinished')) {
      $('.slider-unfinished').css('display', 'block');
    }
});


$(document).on('click', 'button.slider-sizes', function(){
  let images = document.querySelectorAll('.flickity-slider .product-gallery__image img');

  let i = 0;
  for (let img of images) {
    if (img.alt.includes('sizes')) {
      Flickity.data(document.querySelector('.product-gallery__main.flickity-enabled')).select(i);

      $('html, body').animate({
        scrollTop: $('.flickity-slider').offset().top - 150
      }, 500);
      
      return;
    }
    i += 1;
  }

});


$(document).on('click', 'button.slider-inspiration', function(){
  let images = document.querySelectorAll('.flickity-slider .product-gallery__image img');

  let i = 0;
  for (let img of images) {
    if (img.alt.includes('inspiration')) {
      Flickity.data(document.querySelector('.product-gallery__main.flickity-enabled')).select(i);

      $('html, body').animate({
        scrollTop: $('.flickity-slider').offset().top - 150
      }, 500);
      
      return;
    }
    i += 1;
  }
});


$(document).on('click', 'button.slider-unfinished', function(){
  let images = document.querySelectorAll('.flickity-slider .product-gallery__image img');

  let i = 0;
  for (let img of images) {
    if (img.alt.includes('unfinished')) {
      Flickity.data(document.querySelector('.product-gallery__main.flickity-enabled')).select(i);

      $('html, body').animate({
        scrollTop: $('.flickity-slider').offset().top - 150
      }, 500);
      
      return;
    }
    i += 1;
  }
});




  
});






 let header = $('#shopify-section-sections--14625958953015__header');                                                                                                                                
  let logo = header.find('.logo a.logo-align--center')[0];                                                                                                                                            
  let simplified = false;                                                                                                                                                                             
  let locked = false;
  let ticking = false;

  function simplify(animate) {
      if (locked) return;
      locked = true;

      if (animate) {
          const height = logo.offsetHeight;
          logo.style.height = height + 'px';
          logo.style.overflow = 'hidden';
          logo.offsetHeight;

          logo.style.transition = 'height 0.4s ease, opacity 0.4s ease, transform 0.4s ease';
          logo.style.height = '0';
          logo.style.opacity = '0';
          logo.style.transform = 'scaleY(0.5)';
      } else {
          logo.style.height = '0';
          logo.style.overflow = 'hidden';
          logo.style.opacity = '0';
          logo.style.transform = 'scaleY(0.5)';
      }

      header.addClass('simplified-elem');
      simplified = true;
      setTimeout(() => { locked = false; }, 500);
  }

  function expand() {
      if (locked) return;
      locked = true;

      header.removeClass('simplified-elem');
      logo.style.height = 'auto';
      const height = logo.offsetHeight;
      logo.style.height = '0';
      logo.offsetHeight;

      logo.style.transition = 'height 0.4s ease, opacity 0.4s ease, transform 0.4s ease';
      logo.style.height = height + 'px';
      logo.style.opacity = '1';
      logo.style.transform = 'scaleY(1)';
      simplified = false;

      logo.addEventListener('transitionend', function cleanup(e) {
          if (e.propertyName === 'height') {
              logo.style.height = 'auto';
              logo.style.overflow = '';
              logo.style.transition = '';
              logo.style.transform = '';
              logo.removeEventListener('transitionend', cleanup);
              locked = false;
          }
      });
  }

  // Run on page load without animation
  if ($(window).scrollTop() > 120) {
      simplify(true);
  }

  $(window).on('scroll', function () {
      if (!ticking) {
          requestAnimationFrame(function () {
              const scroll = $(window).scrollTop();
              if (scroll > 120 && !simplified) simplify(true);
              else if (scroll < 60 && simplified) expand();
              ticking = false;
          });
          ticking = true;
      }
  });





